import { render } from "./TVshowsView.vue?vue&type=template&id=1dd1f880"
import script from "./TVshowsView.vue?vue&type=script&lang=js"
export * from "./TVshowsView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__